import { render } from "./UploadWarp.vue?vue&type=template&id=1cf493e8&scoped=true"
import script from "./UploadWarp.vue?vue&type=script&lang=js"
export * from "./UploadWarp.vue?vue&type=script&lang=js"

import "./UploadWarp.vue?vue&type=style&index=0&id=1cf493e8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cf493e8"]])

export default __exports__